// import { useEffect, useMemo, useState } from 'react';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import { useParams } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import { ntxAPI } from '@API/axiosNeatex';
// import { useAppDispatch, useAppSelector } from '@store/hooks';
// import {
//   getPagedData,
//   setEndpoint,
//   setFixedFilters,
//   setPagination,
//   setQueryParams
// } from '@store/DynamicFilter/dynamicTableSlice';
// import useGetOrganizations from '@hooks/HR/use-get-organizations';

// import ItemsNotInInventory from './ItemsNotInInventory';
// import ItemsInInventory from './ItemsInInventory';

// const TABLE_KEY_OUT = 'Inventory_ItemsOut';
// const TABLE_KEY_IN = 'Inventory_ItemsIn';

// const NULL_FIXED = {
//   itemCode: null,
//   name: null,
//   categoryId: null,
//   unitOfMeasure: null,
//   brandId: null,
//   barcode: null,
//   itemType: null
// };

// const getKey = (item: any) => String(item?.id ?? '');

// const AssignmentItems = () => {
//   const { inventoryId } = useParams<{ inventoryId: string }>();
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   const { OrganizationInventory } = useGetOrganizations();
//   const inv = OrganizationInventory?.find((f: any) => f?.id === inventoryId);

//   const outTable = useAppSelector(state => state.dynamicTable[TABLE_KEY_OUT]);
//   const inTable = useAppSelector(state => state.dynamicTable[TABLE_KEY_IN]);

//   const outData = (outTable?.data ?? []) as any[];
//   const inData = (inTable?.data ?? []) as any[];

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   // OUT selection + pending changes
//   const [selectedOutMap, setSelectedOutMap] = useState<Record<string, any>>({});
//   const [pendingAddMap, setPendingAddMap] = useState<Record<string, any>>({});
//   const [pendingRemoveMap, setPendingRemoveMap] = useState<Record<string, any>>({});

//   const [isAssigning, setIsAssigning] = useState(false);
// const [isRemoving, setIsRemoving] = useState(false);


//   useEffect(() => {
//     if (!inventoryId) return;

//     // reset pending
//     setSelectedOutMap({});
//     setPendingAddMap({});
//     setPendingRemoveMap({});

//     // OUT
//     dispatch(setEndpoint({ tableKey: TABLE_KEY_OUT, endpoint: 'Inv/GetMasterItemsListOutInventoryId_Paged' }));
//     dispatch(setQueryParams({ tableKey: TABLE_KEY_OUT, queryParams: { InventoryId: inventoryId } }));
//     dispatch(setPagination({ tableKey: TABLE_KEY_OUT, pageIndex: 0, pageSize: 20 }));
//     dispatch(setFixedFilters({ tableKey: TABLE_KEY_OUT, fixedFilters: { ...NULL_FIXED } }));

//     // IN
//     dispatch(setEndpoint({ tableKey: TABLE_KEY_IN, endpoint: 'Inv/GetMasterItemsListByInventoryId_Paged' }));
//     dispatch(setQueryParams({ tableKey: TABLE_KEY_IN, queryParams: { InventoryId: inventoryId } }));
//     dispatch(setPagination({ tableKey: TABLE_KEY_IN, pageIndex: 0, pageSize: 20 }));
//     dispatch(setFixedFilters({ tableKey: TABLE_KEY_IN, fixedFilters: { ...NULL_FIXED } }));

//     dispatch(getPagedData({ tableKey: TABLE_KEY_OUT }));
//     dispatch(getPagedData({ tableKey: TABLE_KEY_IN }));
//   }, [inventoryId, dispatch]);

//   // Hide items that are pending add from OUT view
//   const outVisible = useMemo(() => outData.filter(it => !pendingAddMap[getKey(it)]), [outData, pendingAddMap]);

//   // IN view = server IN minus pending remove + add pending add on top
//   const inVisible = useMemo(() => {
//     const map = new Map<string, any>();

//     for (const it of inData) {
//       const k = getKey(it);
//       if (!pendingRemoveMap[k]) map.set(k, it);
//     }
//     for (const [k, it] of Object.entries(pendingAddMap)) map.set(k, it);

//     return Array.from(map.values());
//   }, [inData, pendingAddMap, pendingRemoveMap]);

//   const isPendingAdd = (item: any) => !!pendingAddMap[getKey(item)];

//   // OUT selection
//   const toggleSelectOut = (item: any) => {
//     const k = getKey(item);
//     if (!k) return;

//     setSelectedOutMap(prev => {
//       const next = { ...prev };
//       if (next[k]) delete next[k];
//       else next[k] = item;
//       return next;
//     });
//   };

//   const selectAllVisibleOut = (visibleItems: any[]) => {
//     setSelectedOutMap(prev => {
//       const next = { ...prev };
//       visibleItems.forEach(it => {
//         const k = getKey(it);
//         if (k) next[k] = it;
//       });
//       return next;
//     });
//   };

//   const deselectAllVisibleOut = (visibleItems: any[]) => {
//     setSelectedOutMap(prev => {
//       const next = { ...prev };
//       visibleItems.forEach(it => {
//         const k = getKey(it);
//         if (k) delete next[k];
//       });
//       return next;
//     });
//   };

//   const addSelectedToPending = () => {
//     const selected = Object.values(selectedOutMap);
//     if (!selected.length) return;

//     setPendingAddMap(prev => {
//       const next = { ...prev };
//       selected.forEach(it => {
//         const k = getKey(it);
//         if (k) next[k] = it;
//       });
//       return next;
//     });

//     // If it was pending remove, cancel remove (undo remove)
//     setPendingRemoveMap(prev => {
//       const next = { ...prev };
//       selected.forEach(it => {
//         const k = getKey(it);
//         if (k && next[k]) delete next[k];
//       });
//       return next;
//     });

//     setSelectedOutMap({});
//   };

//   // Remove from IN:
//   // - if it's pending add => just cancel add
//   // - else mark pending remove
//   const removeItems = (items: any[]) => {
//     if (!items?.length) return;

//     setPendingAddMap(prev => {
//       const next = { ...prev };
//       items.forEach(it => {
//         const k = getKey(it);
//         if (k && next[k]) delete next[k];
//       });
//       return next;
//     });

//     setPendingRemoveMap(prev => {
//       const next = { ...prev };
//       items.forEach(it => {
//         const k = getKey(it);
//         if (!k) return;
//         // mark remove only if it wasn't newly added (pendingAddMap at the time of click)
//         if (!pendingAddMap[k]) next[k] = it;
//       });
//       return next;
//     });
//   };

//   const pendingSummary = useMemo(() => {
//     const add = Object.keys(pendingAddMap).length;
//     const rem = Object.keys(pendingRemoveMap).length;
//     return { add, rem, has: add + rem > 0 };
//   }, [pendingAddMap, pendingRemoveMap]);

//   const onSubmit = async () => {
//     if (!inventoryId) return;

//     const addIds = Object.values(pendingAddMap)
//       .map(it => it?.id)
//       .filter(Boolean);

//     const removeIds = Object.values(pendingRemoveMap)
//       .map(it => it?.id)
//       .filter(Boolean);

//     if (addIds.length === 0 && removeIds.length === 0) {
//       CustomAlert({ action: 'info', msg: 'لا توجد تغييرات للحفظ' });
//       return;
//     }

//     setIsSubmitting(true);
//     try {
//       // add
//       if (addIds.length) {
//         const body = { inventoryId, itemIds: addIds };
//         const res = await ntxAPI.post('Inv/assignmentItems', body);
//         if (res?.data?.succeeded === false) throw new Error(res?.data?.message ?? 'Add failed');
//       }

//       // remove
//       if (removeIds.length) {
//         const body = { inventoryId, itemIds: removeIds };
//         const res = await ntxAPI.post('Inv/DeleteAssignmentItem', body);
//         if (res?.data?.succeeded === false) throw new Error(res?.data?.message ?? 'Remove failed');
//       }

//       CustomAlert({ action: 'Add', msg: 'تم حفظ التغييرات بنجاح' });

//       setSelectedOutMap({});
//       setPendingAddMap({});
//       setPendingRemoveMap({});

//       dispatch(getPagedData({ tableKey: TABLE_KEY_OUT }));
//       dispatch(getPagedData({ tableKey: TABLE_KEY_IN }));
//     } catch (e) {
//       console.error(e);
//       CustomAlert({ action: 'Error', msg: 'حدث خطأ أثناء حفظ التغييرات' });
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             { name: 'Home', link: ':moduleHome' },
//             { name: 'Inventories', link: '/INV/InventorySettings/Inventory' },
//             { name: 'ManageInventoryItems', link: null }
//           ]}
//           PageName={t('ManageInventoryItems')}
//           subtitle={i18n.language === 'en' ? inv?.name : inv?.name2}
//         />
//       </div>

//       <div className='row gx-3 d-flex align-items-stretch'>
//         <ItemsNotInInventory
//           tableKey={TABLE_KEY_OUT}
//           data={outVisible}
//           selectedOutMap={selectedOutMap}
//           onToggleSelect={toggleSelectOut}
//           onSelectAllVisible={selectAllVisibleOut}
//           onDeselectAllVisible={deselectAllVisibleOut}
//           onAddSelected={addSelectedToPending}
//         />

//         <ItemsInInventory
//           tableKey={TABLE_KEY_IN}
//           data={inVisible}
//           isPendingAdd={isPendingAdd}
//           onRemoveItems={removeItems}
//           onRemoveAllVisible={() => removeItems(inVisible)}
//         />
//       </div>

//       {/* Bottom Save Card */}
//       <div className='mt-3'>
//         <div className='card border-0 shadow-sm'>
//           <div className='card-body d-flex align-items-center justify-content-between flex-wrap gap-2'>
//             <div className='d-flex align-items-center gap-2'>
//               <span className='fw-semibold'>التغييرات المعلّقة:</span>

//               {pendingSummary.has ? (
//                 <span className='badge bg-warning text-dark'>
//                   +{pendingSummary.add} / -{pendingSummary.rem}
//                 </span>
//               ) : (
//                 <span className='text-muted small'>لا توجد تغييرات</span>
//               )}
//             </div>

//             <button
//               disabled={isSubmitting || !pendingSummary.has}
//               onClick={onSubmit}
//               type='button'
//               className='btn btn-theme rounded-1'
//             >
//               {isSubmitting ? (
//                 <div className='spinner-border spinner-border-sm me-2'></div>
//               ) : (
//                 <i className='bi bi-save me-2'></i>
//               )}
//               {isSubmitting ? t('جاري الحفظ...') : t('حفظ التغييرات')}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AssignmentItems;


import { useEffect, useMemo, useRef, useState } from 'react';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import { ntxAPI } from '@API/axiosNeatex';

import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
  getPagedData,
  setEndpoint,
  setFixedFilters,
  setPagination,
  setQueryParams
} from '@store/DynamicSlice/dynamicTableSlice';

import useGetOrganizations from '@hooks/HR/use-get-organizations';

import ItemsNotInInventory from './ItemsNotInInventory';
import ItemsInInventory from './ItemsInInventory';

/**
 * مفاتيح الجداول داخل dynamicTableSlice
 * لازم تكون Unique عشان ما تتداخل الجداول مع بعض
 */
const TABLE_KEY_OUT = 'Inventory_ItemsOut';
const TABLE_KEY_IN = 'Inventory_ItemsIn';

/**
 * هذه الفلاتر الثابتة (Fixed Filters) حسب شكل الـ Request عندك
 * لو الـ API يتوقع حقول زيادة، أضفها هنا
 */
const NULL_FIXED = {
  itemCode: null,
  name: null,
  categoryId: null,
  unitOfMeasure: null,
  brandId: null,
  barcode: null,
  itemType: null
};

/**
 * مفتاح ثابت لكل صنف (مهم للـ maps)
 * في Master Items عادة المفتاح هو id
 */
const getKey = (item: any) => String(item?.id ?? '');

const AssignmentItems = () => {
  const { inventoryId } = useParams<{ inventoryId: string }>();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  /** نستخدم بيانات المخزن للعنوان/الـ breadcrumb */
  const { OrganizationInventory } = useGetOrganizations();
  const inv = OrganizationInventory?.find((f: any) => f?.id === inventoryId);

  /** بيانات الجداول من الـ Redux dynamicTableSlice */
  const outTable = useAppSelector(state => state.dynamicTable[TABLE_KEY_OUT]);
  const inTable = useAppSelector(state => state.dynamicTable[TABLE_KEY_IN]);

  const outData = (outTable?.data ?? []) as any[];
  const inData = (inTable?.data ?? []) as any[];

  /**
   * isAssigning: Loading خاص بزر (حفظ الإضافات)
   * isRemoving: Loading خاص بزر (حفظ الإزالات)
   */
  const [isAssigning, setIsAssigning] = useState(false);
  const [isRemoving, setIsRemoving] = useState(false);

  /**
   * selectedOutMap: تحديد العناصر من جدول OUT (غير معيّنة) قبل إضافتها
   * pendingAddMap: عناصر “قيد الإضافة” (لم تُحفظ بعد)
   * pendingRemoveMap: عناصر “قيد الإزالة” (لم تُحفظ بعد)
   */
  const [selectedOutMap, setSelectedOutMap] = useState<Record<string, any>>({});
  const [pendingAddMap, setPendingAddMap] = useState<Record<string, any>>({});
  const [pendingRemoveMap, setPendingRemoveMap] = useState<Record<string, any>>({});

  /** refs لضمان أحدث قيمة داخل callbacks (تجنب مشاكل stale closures) */
  const pendingAddRef = useRef(pendingAddMap);
  const pendingRemoveRef = useRef(pendingRemoveMap);

  useEffect(() => {
    pendingAddRef.current = pendingAddMap;
  }, [pendingAddMap]);

  useEffect(() => {
    pendingRemoveRef.current = pendingRemoveMap;
  }, [pendingRemoveMap]);

  /**
   * تهيئة الجدولين (OUT / IN) مع Pagination + QueryParams
   * - OUT: أصناف غير معيّنة في المخزن
   * - IN : أصناف معيّنة في المخزن
   */
  useEffect(() => {
    if (!inventoryId) return;

    // تصفير أي تغييرات معلّقة عند تغيير المخزن
    setSelectedOutMap({});
    setPendingAddMap({});
    setPendingRemoveMap({});

    // OUT (غير معيّنة)
    dispatch(setEndpoint({ tableKey: TABLE_KEY_OUT, endpoint: 'Inv/GetMasterItemsListOutInventoryId_Paged' }));
    dispatch(setQueryParams({ tableKey: TABLE_KEY_OUT, queryParams: { InventoryId: inventoryId } }));
    dispatch(setPagination({ tableKey: TABLE_KEY_OUT, pageIndex: 1, pageSize: 20 }));
    dispatch(setFixedFilters({ tableKey: TABLE_KEY_OUT, fixedFilters: { ...NULL_FIXED } }));

    // IN (المعيّنة)
    dispatch(setEndpoint({ tableKey: TABLE_KEY_IN, endpoint: 'Inv/GetMasterItemsListByInventoryId_Paged' }));
    dispatch(setQueryParams({ tableKey: TABLE_KEY_IN, queryParams: { InventoryId: inventoryId } }));
    dispatch(setPagination({ tableKey: TABLE_KEY_IN, pageIndex: 1, pageSize: 20 }));
    dispatch(setFixedFilters({ tableKey: TABLE_KEY_IN, fixedFilters: { ...NULL_FIXED } }));

    // أول جلب للبيانات
    dispatch(getPagedData({ tableKey: TABLE_KEY_OUT }));
    dispatch(getPagedData({ tableKey: TABLE_KEY_IN }));
  }, [inventoryId, dispatch]);

  /**
   * outVisible:
   * نخفي من OUT العناصر التي هي قيد الإضافة (pendingAdd)
   * حتى لا تظهر للمستخدم كأنها "غير معيّنة" وهي فعليًا تم اختيارها للإضافة
   */
  const outVisible = useMemo(() => outData.filter(it => !pendingAddMap[getKey(it)]), [outData, pendingAddMap]);

  /**
   * inVisible:
   * نعرض: عناصر IN القادمة من السيرفر (مع استثناء pendingRemove)
   * ونضيف فوقها عناصر pendingAdd (تظهر كأنها ضمن المخزن مع Badge "قيد الإضافة")
   */
  const inVisible = useMemo(() => {
    const map = new Map<string, any>();

    for (const it of inData) {
      const k = getKey(it);
      if (!pendingRemoveMap[k]) map.set(k, it);
    }
    for (const [k, it] of Object.entries(pendingAddMap)) map.set(k, it);

    return Array.from(map.values());
  }, [inData, pendingAddMap, pendingRemoveMap]);

  /** هل العنصر قيد الإضافة؟ (لإظهار Badge في IN) */
  const isPendingAdd = (item: any) => !!pendingAddMap[getKey(item)];

  // =========================
  // عمليات تحديد OUT
  // =========================

  const toggleSelectOut = (item: any) => {
    const k = getKey(item);
    if (!k) return;

    setSelectedOutMap(prev => {
      const next = { ...prev };
      if (next[k]) delete next[k];
      else next[k] = item;
      return next;
    });
  };

  const selectAllVisibleOut = (visibleItems: any[]) => {
    setSelectedOutMap(prev => {
      const next = { ...prev };
      visibleItems.forEach(it => {
        const k = getKey(it);
        if (k) next[k] = it;
      });
      return next;
    });
  };

  const deselectAllVisibleOut = (visibleItems: any[]) => {
    setSelectedOutMap(prev => {
      const next = { ...prev };
      visibleItems.forEach(it => {
        const k = getKey(it);
        if (k) delete next[k];
      });
      return next;
    });
  };

  /**
   * إضافة المحدد من OUT إلى pendingAdd
   * مع إلغاء الإزالة إن كانت موجودة (من باب الاتساق)
   */
  const addSelectedToPending = () => {
    const selected = Object.values(selectedOutMap);
    if (!selected.length) return;

    setPendingAddMap(prev => {
      const next = { ...prev };
      selected.forEach(it => {
        const k = getKey(it);
        if (k) next[k] = it;
      });
      return next;
    });

    // إذا كان الصنف (نظريًا) ضمن pendingRemove، نحذف اسمه من pendingRemove (undo remove)
    setPendingRemoveMap(prev => {
      const next = { ...prev };
      selected.forEach(it => {
        const k = getKey(it);
        if (k && next[k]) delete next[k];
      });
      return next;
    });

    setSelectedOutMap({});
  };

  // =========================
  // عمليات الإزالة من IN
  // =========================

  /**
   * removeItems:
   * - إذا كان الصنف ضمن pendingAdd => نلغي إضافته فقط
   * - إذا كان عنصر أصلي داخل المخزن => نضيفه لـ pendingRemove
   */
  const removeItems = (items: any[]) => {
    if (!items?.length) return;

    // 1) إلغاء أي pendingAdd لهذه العناصر
    setPendingAddMap(prev => {
      const next = { ...prev };
      items.forEach(it => {
        const k = getKey(it);
        if (k && next[k]) delete next[k];
      });
      return next;
    });

    // 2) إضافة العناصر لـ pendingRemove إذا لم تكن pendingAdd
    setPendingRemoveMap(prev => {
      const next = { ...prev };
      const addNow = pendingAddRef.current; // أحدث pendingAdd

      items.forEach(it => {
        const k = getKey(it);
        if (!k) return;

        // إذا ما كان newly-added نحطه pending remove
        if (!addNow[k]) next[k] = it;
      });

      return next;
    });
  };

  // =========================
  // ملخص التغييرات + IDs
  // =========================

  const addIds = useMemo(
    () => Object.values(pendingAddMap).map(it => it?.id).filter(Boolean),
    [pendingAddMap]
  );

  const removeIds = useMemo(
    () => Object.values(pendingRemoveMap).map(it => it?.id).filter(Boolean),
    [pendingRemoveMap]
  );

  const pendingSummary = useMemo(() => {
    const add = addIds.length;
    const rem = removeIds.length;
    return { add, rem, has: add + rem > 0 };
  }, [addIds, removeIds]);

  // =========================
  // ✅ بوست منفصل لكل عملية
  // =========================

  /**
   * حفظ الإضافات فقط
   * endpoint: Inv/assignmentItems
   * body: { inventoryId, itemIds: [] }
   */
  const submitAssign = async () => {
    if (!inventoryId) return;

    if (!addIds.length) {
      CustomAlert({ action: 'info', msg: 'لا توجد أصناف للإضافة' });
      return;
    }

    setIsAssigning(true);
    try {
      const body = { inventoryId, itemIds: addIds };
      const res = await ntxAPI.post('Inv/assignmentItems', body);

      // بعض الـ APIs ترجع succeeded/message… نتعامل معها إن وجدت
      if (res?.data?.succeeded === false) {
        throw new Error(res?.data?.message ?? 'Assign failed');
      }

      CustomAlert({ action: 'Add', msg: 'تم تعيين الأصناف للمخزن بنجاح' });

      // بعد نجاح الإضافة: نصفر pendingAdd فقط
      setPendingAddMap({});
      setSelectedOutMap({});

      // إعادة تحميل الجدولين لإظهار الحالة الحقيقية من السيرفر
      dispatch(getPagedData({ tableKey: TABLE_KEY_OUT }));
      dispatch(getPagedData({ tableKey: TABLE_KEY_IN }));
    } catch (e) {
      console.error(e);
      CustomAlert({ action: 'Error', msg: 'فشل تعيين الأصناف للمخزن' });
    } finally {
      setIsAssigning(false);
    }
  };

  /**
   * حفظ الإزالات فقط
   * endpoint: Inv/DeleteAssignmentItem
   * body: { inventoryId, itemIds: [] }
   */
  const submitRemove = async () => {
    if (!inventoryId) return;

    if (!removeIds.length) {
      CustomAlert({ action: 'info', msg: 'لا توجد أصناف للإزالة' });
      return;
    }

    setIsRemoving(true);
    try {
      const body = { inventoryId, itemIds: removeIds };
      const res = await ntxAPI.post('Inv/DeleteAssignmentItem', body);

      if (res?.data?.succeeded === false) {
        throw new Error(res?.data?.message ?? 'Remove failed');
      }

      CustomAlert({ action: 'Add', msg: 'تم إزالة الأصناف من المخزن بنجاح' });

      // بعد نجاح الإزالة: نصفر pendingRemove فقط
      setPendingRemoveMap({});

      // إعادة تحميل الجدولين
      dispatch(getPagedData({ tableKey: TABLE_KEY_OUT }));
      dispatch(getPagedData({ tableKey: TABLE_KEY_IN }));
    } catch (e) {
      console.error(e);
      CustomAlert({ action: 'Error', msg: 'فشل إزالة الأصناف من المخزن' });
    } finally {
      setIsRemoving(false);
    }
  };

  return (
    <div>
      {/* العنوان */}
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            { name: 'Home', link: ':moduleHome' },
            { name: 'Inventories', link: '/INV/InventorySettings/Inventory' },
            { name: 'ManageInventoryItems', link: null }
          ]}
          PageName={t('ManageInventoryItems')}
          subtitle={i18n.language === 'en' ? inv?.name : inv?.name2}
        />
      </div>

      {/* الجداول (يمين/يسار) */}
      <div className='row gx-3 d-flex align-items-stretch'>
        {/* OUT: أصناف غير معينة */}
        <ItemsNotInInventory
          tableKey={TABLE_KEY_OUT}
          data={outVisible}
          selectedOutMap={selectedOutMap}
          onToggleSelect={toggleSelectOut}
          onSelectAllVisible={selectAllVisibleOut}
          onDeselectAllVisible={deselectAllVisibleOut}
          onAddSelected={addSelectedToPending}
        />

        {/* IN: أصناف معينة */}
        <ItemsInInventory
          tableKey={TABLE_KEY_IN}
          data={inVisible}
          isPendingAdd={isPendingAdd}
          onRemoveItems={removeItems}
          onRemoveAllVisible={() => removeItems(inVisible)}
        />
      </div>

      {/* كرت الأزرار في أسفل الصفحة */}
      <div className='mt-3'>
        <div className='card border-0 shadow-sm'>
          <div className='card-body d-flex align-items-center justify-content-between flex-wrap gap-2'>
            <div className='d-flex align-items-center gap-2'>
              <span className='fw-semibold'>التغييرات المعلّقة:</span>

              {pendingSummary.has ? (
                <span className='badge bg-warning text-dark'>
                  +{pendingSummary.add} / -{pendingSummary.rem}
                </span>
              ) : (
                <span className='text-muted small'>لا توجد تغييرات</span>
              )}
            </div>

            {/* ✅ زر لكل عملية (بوست مستقل) */}
            <div className='d-flex gap-2'>
              <button
                disabled={isAssigning || addIds.length === 0}
                onClick={submitAssign}
                type='button'
                className='btn btn-theme rounded-1'
              >
                {isAssigning ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='bi bi-plus-circle me-2'></i>
                )}
                حفظ الإضافات ({addIds.length})
              </button>

              <button
                disabled={isRemoving || removeIds.length === 0}
                onClick={submitRemove}
                type='button'
                className='btn btn-danger rounded-1'
              >
                {isRemoving ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='bi bi-dash-circle me-2'></i>
                )}
                حفظ الإزالات ({removeIds.length})
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignmentItems;
